import { render } from "./ClientInList.vue?vue&type=template&id=64077684"
import script from "./ClientInList.vue?vue&type=script&lang=js"
export * from "./ClientInList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__